
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M8.955.042a1.031 1.031 0 00-.68.302L.343 8.277a1.031 1.031 0 000 1.455l7.934 7.934a1.031 1.031 0 001.456 0 1.031 1.031 0 000-1.457L2.527 9.006 9.73 1.799a1.031 1.031 0 000-1.457A1.031 1.031 0 008.953.04z","overflow":"visible"}}),_c('path',{attrs:{"d":"M16.888.042a1.031 1.031 0 00-.679.302L8.276 8.277a1.031 1.031 0 000 1.455l7.933 7.934a1.031 1.031 0 001.457 0 1.031 1.031 0 000-1.457L10.46 9.006l7.203-7.207a1.031 1.031 0 000-1.457 1.031 1.031 0 00-.777-.302z","overflow":"visible"}})])])
          )
        }
      }
    